export default __webpack_public_path__ + "c2742c586726b8aad66dd67e4d1ad6c5.png";